import { faWarning } from '@fortawesome/free-solid-svg-icons';
import { faSpinnerThird } from '@fortawesome/pro-duotone-svg-icons';
import { faCheckCircle, faTimesCircle } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Button from 'components/shared/Button.styled';
import { useI18n } from 'hooks/useI18n';
import { useCallback, useState } from 'react';
import {
  StyledActions,
  StyledIcon,
  StyledText,
  StyledTitle,
  StyledWrapper
} from './ChangePasswordRequestNotSent.styled';
import { ChangePasswordRequestNotSentProps } from './ChangePasswordRequestNotSent.types';

export const ChangePasswordRequestNotSent: React.FC<
  ChangePasswordRequestNotSentProps
> = ({ onAccept, onCancel }) => {
  const { t } = useI18n('portal-settings');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleConfirmClick = useCallback(async () => {
    try {
      setIsSubmitting(true);

      await onAccept();

      setIsSubmitting(false);
    } catch (ex) {
      setIsSubmitting(false);
    }
  }, [onAccept]);

  return (
    <StyledWrapper>
      <StyledIcon>
        <FontAwesomeIcon icon={faWarning} />
      </StyledIcon>
      <StyledTitle>
        {t('portal-settings.account.form.password.confirm.not-sent.title')}
      </StyledTitle>
      <StyledText>
        {t('portal-settings.account.form.password.confirm.not-sent.text')}
      </StyledText>
      <StyledActions>
        <Button
          variant="primary"
          aria-label={t(
            'portal-settings.account.form.password.confirm.not-sent.actions.confirm'
          )}
          onClick={handleConfirmClick}
          isLoading={isSubmitting}
        >
          {!isSubmitting && <FontAwesomeIcon icon={faCheckCircle} />}
          {isSubmitting && <FontAwesomeIcon icon={faSpinnerThird} />}

          <span aria-hidden="true">
            {t(
              'portal-settings.account.form.password.confirm.not-sent.actions.confirm'
            )}
          </span>
        </Button>

        <Button
          variant="secondary"
          aria-label={t(
            'portal-settings.account.form.password.confirm.not-sent.actions.cancel'
          )}
          onClick={onCancel}
        >
          <FontAwesomeIcon icon={faTimesCircle} />
          <span aria-hidden="true">
            {t(
              'portal-settings.account.form.password.confirm.not-sent.actions.cancel'
            )}
          </span>
        </Button>
      </StyledActions>
    </StyledWrapper>
  );
};
